/**
 * Mounts the appropriate page-level tutorial based on the current route.
 *
 * Route → tutorial id map:
 *   /              → dashboard
 *   /feed-resume   → resume
 *   /feed-job      → jd
 *   /skills, /skills/new, /skills/:id  → skills
 *   /network       → network
 *   /studio        → studio
 *
 * Auto-open is disabled until the user has dismissed the global
 * OnboardingTour (so we don't stack two modals on first load).
 */
import React from "react";
import { useLocation } from "react-router-dom";
import PageTutorial from "./PageTutorial";
import { useAuth } from "../context/AuthContext";

const RULES = [
  { test: (p) => p === "/",                            id: "dashboard" },
  { test: (p) => p.startsWith("/feed-resume"),         id: "resume"    },
  { test: (p) => p.startsWith("/feed-job"),            id: "jd"        },
  { test: (p) => p.startsWith("/network"),             id: "network"   },
  { test: (p) => p.startsWith("/studio"),              id: "studio"    },
  { test: (p) => p.startsWith("/skills"),              id: "skills"    },
];

export default function RoutedTutorials() {
  const location = useLocation();
  const { user } = useAuth();
  // Don't show the tour pill until the user is past the beta-gate AND logged in.
  if (!user) return null;
  const path = location.pathname;
  const match = RULES.find((r) => r.test(path));
  if (!match) return null;
  return <PageTutorial key={match.id} id={match.id} autoOpenDelay={2200} />;
}
